import type { ReactNode } from 'react';
import type { PermissionCode } from '@pms/shared';
import { usePermission } from '@/hooks/usePermission';

interface PermissionGateProps {
  permission?: PermissionCode;
  permissions?: PermissionCode[];
  mode?: 'any' | 'all';
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({
  permission,
  permissions,
  mode = 'any',
  children,
  fallback = null,
}: PermissionGateProps) {
  const perms = usePermission();
  const codes = permission ? [permission] : (permissions ?? []);
  if (codes.length === 0) return <>{children}</>;
  const ok = mode === 'all' ? perms.hasAll(codes) : perms.hasAny(codes);
  return <>{ok ? children : fallback}</>;
}
